import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
@Component({
    selector: 'app-apply-leaves',
    templateUrl: './apply-leaves.component.html',
    styleUrls: ['./apply-leaves.component.css'],
    standalone: true,
    imports: [FormsModule, RouterModule],
    providers: [DatePipe],
})
export class ApplyLeavesComponent { }
// export class ApplyLeavesComponent implements OnInit {
//   text: string = '';
//   public showSpinner: boolean = false;
//   public user: any = [];
//   public isHidden: boolean = false;
//   public dateShow: boolean = true;
//   public absent: any = '';
//   public isEdit: boolean = false;
//   public stats: any = [];
//   bsInlineValue = new Date();
//   bsInlineRangeValue: Date[];
//   maxDate = new Date();
//   public paidLeaves: any = 0;
//   public rejectedLeaves: any = 0;
//   public renewalYear = new Date().getFullYear();
//   lastWorkingDay: any;
//   hidenData: any
//   userInfo: any;
//   colormode: any;
//   selectedMode: any;
//   datamode: any;
//   source: any;
//   total_leave: any;
//   leavenames: any;
//   leave_types: any;
//   selectedLeave: string = '';
//   selectedPaymentStatus: string = '';
//   selectedLeaveName: any;
//   checkLeave: any;
//   start_date_form: any;
//   end_date_form: any;
//   applyButton: boolean = false;
//   leave_type: any;
//   leave_type_id: any;
//   selectedStaffImage: string | null = null;
//   selectedStaffName: string | null = null;
//   otherusers: any;
//   selectedUserName: string = ''; // Holds the selected user's name
//   selectedUserImage: string = '';
//   selectedLeaveType: string = 'self';
//   searchQuery: any;
//   selectedUserId: any;
//   leave_category: any;
//   filteredUsers: any;
//   userroleParse: any;
//   user_role: any;
//   remainleaves: any;
//   joiningDate: any;
//   appliedleaveData: any;
//   formdata: any;
//   otherUserid: any;
//   isDateInput: boolean = false;  // Flag to track the input type
//   isTouched: boolean = false;
//   isEndDateInput: boolean = false;
//   isEndDateTouched: boolean = false;

//   constructor(
//     private _leaveService: LeaveService,
//     private leaveService: LeaveService,
//     private router: Router,
//     private route: ActivatedRoute,
//     private attendaceService: AttendanceService,
//     private sharedmode: SharedModeService,
//     public dashboardService: DashboardService,
//     private location: Location,
//     public datepipe: DatePipe
//   ) {

//     var date = new Date();
//     this.isEdit = this.route.snapshot.queryParams.isEdit ?? false;
//     if (this.isEdit) {
//       this.hidenData = JSON.parse(this.route.snapshot.queryParams.data);
//     }

//     let lastFifthDayDate = date.getDate() - 4 > 0 ? date.getDate() - 9 : 25;

//     let month = date.getDate() - 4 > 0 ? date.getMonth() : date.getMonth() - 1;


//     let startdate = this.datepipe.transform(new Date(date.getFullYear(), month, lastFifthDayDate), 'yyyy/MM/dd');
//     let endDate = this.datepipe.transform(new Date(date.getFullYear(), month + 1, 0), 'yyyy/MM/dd');
//     this.attendaceService.getAttendance(startdate, endDate, null, null).then(response => {
//       if (response.data.attendance.length > 0) {
//         let index = response.data.attendance.slice().reverse().findIndex((x: any) => x.check_in != "" && x.check_out != "");
//         if (index >= 0) {
//           var finalIndex = index >= 0 ? (response.data.attendance.length - 1) - index : index;
//           this.lastWorkingDay = new Date(response.data.attendance[finalIndex].date);
//         }
//         else {
//           this.lastWorkingDay = new Date(date.getFullYear(), month, 1);
//         }
//       }
//     });
//     this.user = JSON.parse(localStorage.getItem('user') || '');
//     this.maxDate.setDate(this.maxDate.getDate() + 7);
//     this.bsInlineRangeValue = [this.bsInlineValue, this.maxDate];
//     this.user_detail();
//   }

//   ngOnInit(): void {
//     this.paidLeaves = this.route.snapshot.paramMap.get('paidLeaves');
//     this.rejectedLeaves = this.route.snapshot.paramMap.get('rejectedLeaves');
//     this.paidLeaves = +this.paidLeaves;
//     this.rejectedLeaves = +this.rejectedLeaves;
//     this.sharedmode.data$.subscribe(mode => {
//       this.selectedMode = mode;
//     });
//     if (this.hidenData?.description) {
//       this.text = this.hidenData.description;  // Pre-fill the text with the description
//     }

//     // this.getOtherUser();
//   }

//   toggleMode(mode: string) {
//     this.datamode
//     this.sharedmode.setMode(mode);
//   }
//   trimText() {
//     this.text = this.text.replace(/\s+/g, ' ').trim();
//   }

//   getLeaveStats() {
//     this.leaveService.getStatsFilter().then((value) => {
//       this.absent = value.data.absents;
//       this.stats = value.data.leaves;

//     });
//   }
//   onSubmit(f: NgForm) {
//     this.getAllLeaveData(f);

//     // this.leavecheck(f);
//   }

//   formSubmit(f: NgForm) {
//     const leaveAction = f.value.leave_action;
//     // this.getAllLeaveData(this.formdata);


//     this.showSpinner = true;
//     this.source = 'web_app';

//     if (this.lastWorkingDay === undefined || this.lastWorkingDay === null) {
//       this.lastWorkingDay = new Date();
//     }
//     let month = this.lastWorkingDay.getMonth();
//     let day = this.lastWorkingDay.getDate() - 5;
//     if (day < 0) {
//       month = month - 1;
//       day = 30 - (5 - this.lastWorkingDay.getDate());
//     }
//     let lastWorkingDate = new Date(this.lastWorkingDay.getFullYear(), month, day);
//     let leaveStartDate = new Date(f.value.start_date);
//     let leaveEndDate = new Date(f.value.end_date);
//     if (leaveStartDate.getTime() <= lastWorkingDate.getTime()) {
//       this.showSpinner = false;
//       Swal.fire({
//         iconHtml: ' <img src="../../../../assets/images/warning_icon.svg"  alt="image" >',
//         title: "Date should be greater than your last working day's date.",
//         showConfirmButton: false,
//         timer: 2000,
//       });
//     }
//     else {
//       if (f.value.end_date == null) {
//         f.value.end_date = f.value.start_date
//       }
//       else if (leaveEndDate.getTime() < leaveStartDate.getTime()) {
//         this.showSpinner = false;
//         Swal.fire({
//           iconHtml: ' <img src="../../../../assets/images/warning_icon.svg"  alt="image" >',
//           title: "End Date should be greater than or equal to Start Date.",
//           showConfirmButton: false,
//           timer: 2000,
//         });
//       }
//       if (this.isEdit) {
//         // need to do new api call to update the leave

//         this._leaveService
//           .updateLeave(
//             this.hidenData.id,
//             f.value.title,
//             f.value.leave_type_id,
//             f.value.start_date,
//             f.value.end_date,
//             f.value.start_time,
//             f.value.end_time,
//             f.value.leave_payment_status,
//             f.value.description,
//             f.value.short_leave,
//             f.value.leave_name,
//             f.value.leave_action,
//             this.source,
//             f.value.leave_attachment

//           )
//           .then((value) => {
//             this.showSpinner = false;
//             if (value.success == true) {
//               Swal.fire({
//                 iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
//                 title: 'Application Updated Successfully',
//                 showConfirmButton: false,
//                 timer: 1500,
//               });
//               this.router.navigate(['leaves']);
//             } else {
//               Swal.fire({
//                 iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
//                 title: value.message,
//                 showConfirmButton: false,
//                 timer: 3000,
//               });
//             }
//           });
//       } else {
//         this._leaveService
//           .getApplyResult(
//             f.value.title,
//             f.value.leave_type_id,
//             f.value.start_date,
//             f.value.end_date,
//             f.value.start_time,
//             f.value.end_time,
//             f.value.leave_payment_status,
//             f.value.description,
//             f.value.short_leave,
//             f.value.leave_name,
//             this.source,
//             this.selectedUserId,
//             f.value.leave_action,
//             f.value.leave_attachment

//           )
//           .then((value) => {
//             this.showSpinner = false;
//             if (value.success == true) {
//               Swal.fire({
//                 iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
//                 title: 'Application Submitted Successfully',
//                 showConfirmButton: false,
//                 timer: 1500,
//               });
//               this.router.navigate(['leaves']);
//             } else {
//               Swal.fire({
//                 iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
//                 title: value.message,
//                 showConfirmButton: false,
//                 timer: 3000,
//               });
//             }
//           });
//       }
//     }
//   }

//   onCancel(form: NgForm) {
//     form.reset();
//   }

//   checkType(deviceValue: any, value: any) {
//     this.leave_type = value
//     if (value == 3) {
//       this.isHidden = true;
//       this.dateShow = false;
//     } else {
//       this.isHidden = false;
//       this.dateShow = true;
//     }
//   }
//   user_detail() {
//     this.showSpinner = true;
//     this.dashboardService.getuserdetail().then((value) => {
//       this.userInfo = value.data
//       this.total_leave = this.userInfo?.total_leaves
//       this.colormode = this.userInfo.color_mode
//       this.sharedmode.setMode(this.colormode);
//       this.userroleParse = JSON.parse(this.userInfo.user_roles);
//       this.user_role = this.userroleParse?.role_type
//       this.joiningDate = this.userInfo?.joining_date
//       const specifiedDate = new Date('2024-09-01');
//       const userJoiningDate = new Date(this.joiningDate);
//     })
//     this.leavestype();
//     this.showSpinner = false;
//   }

//   leavestype() {
//     this.showSpinner = true;
//     this.dashboardService.getleaves().then((value) => {
//       this.leavenames = value.data
//       this.leave_category = this.leavenames.length;
//       if (this.hidenData?.leave_name) {
//         this.onLeaveNameChange({ target: { value: this.hidenData.leave_name } });
//       }
//       if (this.hidenData && this.hidenData.start_date) {
//         this.start_date_form = this.hidenData.start_date; // Set start date if available
//       }
//       if (this.hidenData && this.hidenData.end_date) {
//         this.end_date_form = this.hidenData.end_date; // Set start date if available
//       }
//       this.showSpinner = false;
//     })
//   }
//   showDatePicker() {
//     this.isDateInput = true;  // Change type to date
//   }

//   // Check if the field is empty after blur and revert to text if needed
//   checkIfEmpty() {
//     if (!this.start_date_form) {
//       this.isDateInput = false;  // Revert to text if no date is selected
//     }
//     this.isTouched = true;  // Mark the field as touched
//   }
//   onLeaveNameChange(event: any) {
//     this.selectedLeaveName = event.target ? event.target.value : this.hidenData?.leave_name; // Use hidden value if in edit mode

//     const filteredLeaves = this.leavenames.filter((leave: any) => leave.leave_name === this.selectedLeaveName);

//     // Reset leave_types
//     this.leave_types = [];

//     // Concatenate all the leave types from the filtered leaves
//     filteredLeaves.forEach((leave: any) => {
//       this.leave_types = this.leave_types.concat(leave.types);
//     });

//     // Pre-select leave type based on hidden data (for editing case)
//     if (this.hidenData?.leave_name === this.selectedLeaveName) {
//       const defaultLeaveType = this.hidenData?.leave_payment_status; // Assuming this holds the payment status (paid/unpaid)
//       this.selectedPaymentStatus = defaultLeaveType; // Pre-select the leave type
//     }
//   }

//   showEndDatePicker() {
//     this.isEndDateInput = true;
//   }

//   // Revert input type to 'text' if no value is selected for the End Date field
//   checkIfEndDateEmpty() {
//     if (!this.end_date_form) {
//       this.isEndDateInput = false; // Change back to text if date is empty
//     }
//     this.isEndDateTouched = true; // Mark input as touched
//   }
//   // onPaymentStatusChange(event: any) {
//   //   const selectedPaymentStatus = event.target.value;
//   //   this.leavecheck(selectedPaymentStatus);
//   // }

//   // onDateChange() {
//   //   this.leavecheck(this.selectedLeaveName);
//   // }

//   selectStaff(name: string, image: string) {
//     this.selectedStaffName = name;
//     this.selectedStaffImage = image;
//   }

//   clearInput() {
//     this.selectedStaffName = null;
//     this.selectedStaffImage = null;
//   }


//   getOtherUser() {
//     this.showSpinner = true;
//     this.dashboardService.getusers().then((value) => {
//       this.otherusers = value.data
//       this.filterUsers()
//     })

//   }


//   // Filter users based on input
//   filterUsers() {
//     if (this.selectedUserName) {
//       this.filteredUsers = this.otherusers.filter((user: any) =>
//         (user.first_name + ' ' + user.last_name).toLowerCase().includes(this.selectedUserName.toLowerCase())
//       );
//     } else {
//       this.filteredUsers = this.otherusers;
//     }
//   }

//   // Call selectUser when user clicks a result
//   // selectUser(user: any) {
//   //   this.selectedUserName = user.first_name + ' ' + user.last_name;
//   //   this.selectedUserImage = user.profile_image;
//   //   this.filteredUsers = []; // Hide the results after selection
//   // }







//   selectUser(user: any): void {
//     this.selectedUserName = `${user.first_name} ${user.last_name}`;
//     this.selectedUserImage = user.profile_image ? user.profile_image : 'assets/images/question.jpg';
//     this.selectedUserId = user?.id
//     // this.leavecheck(this.selectedUserId);
//     this.showSpinner = false;
//   }

//   onLeaveTypeChange(event: any): void {
//     this.selectedLeaveType = event.target.value;
//     if (this.selectedLeaveType === 'other') {
//       this.getOtherUser(); // Call the function when 'Others' is selected
//     }
//     // this.leavecheck(this.selectedLeaveType);
//   }

//   backward() {
//     this.location.back(); // Navigate back to the last URL
//   }



//   leavecheck(f: any) {
//     this.selectedUserId
//     this.selectedLeaveType
//     this.selectedPaymentStatus
//     this.selectedLeaveName
//     this.start_date_form
//     this.end_date_form
//     this.leave_type
//     this.dashboardService.leaveCount(this.selectedPaymentStatus, this.selectedLeaveName, this.start_date_form, this.end_date_form, this.selectedLeaveType, this.selectedUserId).then((value) => {
//       this.checkLeave = value;
//       if (this.checkLeave?.success == true) {
//         this.applyButton = true
//         Swal.fire({
//           iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
//           title: value.message,
//           showConfirmButton: false,
//           timer: 3000,
//         });
//       }
//       else {
//         this.applyButton = false
//         this.formSubmit(f)
//       }
//       this.showSpinner = false;
//     })

//   }


//   remainingLeaves() {
//     this.showSpinner = true;
//     this.dashboardService.getRemainingLeaves().then((value) => {
//       this.remainleaves = value.data.data
//     })
//     this.showSpinner = false;
//   }

//   //    getAllLeaveData() {
//   //     this.leaveService.getAllLeave().then((value) => {
//   //      const leaveData = value.data
//   //       this.showSpinner = false;
//   //     });
//   //   }

//   getAllLeaveData(f: NgForm) {
//     if (this.selectedLeaveType === 'other') {
//       this.otherUserid = this.selectedUserId;
//     }
//     this.leaveService.getAllUserLeave(this.otherUserid).then((value) => {
//       const leaveData = value.data;
//       this.showSpinner = false;
//       this.getRemainingLeaves(leaveData, f.value.start_date, f.value.end_date, f.value.leave_name, f.value.leave_payment_status, f);
//     });
//   }

//   getRemainingLeaves(leaveData: any, startDate: any, endDate: any, leaveName: any, leavePaymentStatus: any, f: NgForm) {
//     this.showSpinner = true;
//     this.dashboardService.getRemainingLeaves().then((value) => {
//       const remainingLeaves = value.data.data;
//       const dateDifference = this.calculateDateDifference(startDate, endDate);

//       this.checkAppliedLeaves(leaveData, remainingLeaves, dateDifference, leaveName, leavePaymentStatus, f);
//     });
//     this.showSpinner = false;
//   }
//   calculateDateDifference(startDate: string, endDate: string) {
//     const start = new Date(startDate);
//     start.setDate(start.getDate() - 1);
//     const end = new Date(endDate);
//     const diffTime = Math.abs(end.getTime() - start.getTime());
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

//     return diffDays;
//   }

//   checkAppliedLeaves(leaveData: any, remainingLeaves: any, dateDifference: any, leaveName: any, leavePaymentStatus: any, f: NgForm) {
//     remainingLeaves.forEach((remainingLeave: any) => {
//       if (remainingLeave.leave_name === leaveName && remainingLeave.leave_type === leavePaymentStatus) {
//         const appliedLeaves = leaveData.filter(
//           (leave: any) =>
//             leave.leave_name === remainingLeave.leave_name &&
//             (leave.status === 'pending' || leave.status === 'approved')
//         ).length;
//         const remainingLeaveCount = remainingLeave.assigned_leaves - remainingLeave.leave_count;

//         if (appliedLeaves >= remainingLeave.assigned_leaves) {
//           this.applyButton = true;
//           Swal.fire({
//             iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
//             title: `You Already Applied ${appliedLeaves} days of ${remainingLeave.leave_name}.`,
//             showConfirmButton: false,
//             timer: 3000,
//           });
//           return

//         }

//         if (dateDifference > remainingLeaveCount) {
//           this.applyButton = true;
//           Swal.fire({
//             iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
//             title: `You can't apply for ${dateDifference} days of ${remainingLeave.leave_name}, only ${remainingLeaveCount} days are remaining.`,
//             showConfirmButton: false,
//             timer: 3000,
//           });
//           return

//         }
//         this.formSubmit(f)
//       }
//     });
//   }


// }

